export default "__VITE_ASSET__929b7001__"